import {createAction, createAsyncThunk, createReducer} from '@reduxjs/toolkit';

import {ENDPOINTS} from 'constants/endpoints';

import {CmsPopupType} from 'desktop/types/cmsPopupType';
import {apiConfig} from 'libs/api/api';
import {getCloudinaryPrefix} from 'libs/cloudinary/cloudinary';

const initialState: CmsPopupType = {
    content: null,
    visibility: false,
};

export const setCmsPopupVisibility = createAction<CmsPopupType | undefined>(
    'CMS_POPUP@SET_VISIBLE',
);

export const openPopupWithCMSBlock = createAsyncThunk<
    CmsPopupType,
    {checkoutStep: string; cmsBlockName: string}
>('CMS_POPUP@OPEN_POPUP_WITH_CMS_BLOCK', async ({checkoutStep, cmsBlockName}) => {
    const {data} = await apiConfig.instanceGusaBackend({
        method: 'get',
        url: `${ENDPOINTS.GET_CMS_PAGE_BY_ID}/${cmsBlockName}?url_prefix=${getCloudinaryPrefix()}`,
    });

    return {
        content: {
            html: data.content,
        },
        params: {checkoutStep, cmsBlockName},
        visibility: true,
    };
});

/**
 * Reducer for checkoutSideReview
 * @param {CmsPopupType} state - reducer state
 * @return {CmsPopupType} new reducer state
 */
export const cmsPopup = createReducer<CmsPopupType>(initialState, builder => {
    builder
        .addCase(setCmsPopupVisibility, (state, action) => action.payload || initialState)
        .addCase(openPopupWithCMSBlock.fulfilled, (state, action) => action.payload);
});
